import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CONNECTIONS_CATALOG } from "@/lib/connectionsCatalog";

export const ConnectionsSideNav = ({ activeKey }) => {
  const navigate = useNavigate();

  const handleClick = (key) => {
    if (key === activeKey) return;
    navigate(`/dashboard/connections#${key}`);
  };

  return (
    <div className="w-full shrink-0 xl:w-64" data-testid="connections-side-nav">
      <Link to="/dashboard/connections" data-testid="connections-side-nav-back" className="mb-4 inline-flex items-center gap-1.5 text-xs font-bold text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white">
        <ArrowLeft size={14} /> Connections
      </Link>
      <div className="space-y-1">
        {CONNECTIONS_CATALOG.map((c) => {
          const active = c.key === activeKey;
          return (
            <button
              key={c.key}
              type="button"
              onClick={() => handleClick(c.key)}
              disabled={c.disabled}
              data-testid={`connections-side-nav-item-${c.key}`}
              className={`flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left transition-colors duration-150 ${
                active
                  ? "bg-blue-50 text-blue-700 ring-1 ring-blue-200 dark:bg-blue-600/15 dark:text-white dark:ring-blue-500/40"
                  : c.disabled
                    ? "cursor-not-allowed text-slate-300 dark:text-slate-600"
                    : "text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-white/5"
              }`}
            >
              <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${c.iconBg}`}>
                <c.icon size={14} className={c.iconColor} strokeWidth={1.8} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-xs font-bold">{c.label}</span>
                <span className="block truncate text-[11px] text-slate-500">{c.subtitle}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
